import React from 'react';
import EffectParameterSlider from '../EffectParameterSlider.js';
import {MIDI_FX} from 'constants/effect-types.js';

export default function EdgeDetails({edge, sequencerEngine, rack}) {
    if (rack.getEffectType() === MIDI_FX) {
        return (
            <div className="edge-properties">
              <div>Edge Properties:</div>
              <EffectParameterSlider
                effectNumber={0}
                automation={undefined}
                name='Probability'
                selectedParameter={undefined}
                sequencerEngine={sequencerEngine}
                lfoEnabled={true}
                parameter={edge.probabilityParameter}
                isParameter={true}
                onParameterChanged={() => []}
                step={0.01}
                max={100}
                min={0}
              />
            </div>
    );
    } else {
        return (
            <div className="edge-properties">
              <div>Edge Properties:</div>
              <EffectParameterSlider
                effectNumber={0}
                automation={undefined}
                name='Gain'
                selectedParameter={undefined}
                sequencerEngine={sequencerEngine}
                lfoEnabled={true}
                parameter={edge.gainParameter}
                isParameter={true}
                onParameterChanged={() => []}
                step={0.01}
                min={0}
                max={1}
              />
            </div>
    );
    }
}
